import { render } from "./NavBar.vue?vue&type=template&id=ce4468ce&scoped=true&bindings={\"count\":\"setup\"}"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=ce4468ce&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-ce4468ce"

export default script